import type { UIMessage } from '@ai-sdk/react';

export function deriveLabel(messages: UIMessage[]): string {
    const firstUser = messages.find((m) => m.role === 'user');
    if (!firstUser) return 'New chat';

    const text = firstUser.parts
        .filter((p): p is { type: 'text'; text: string } => p.type === 'text')
        .map((p) => p.text)
        .join('');

    if (!text) return 'New chat';
    return text.length > 50 ? text.slice(0, 47) + '...' : text;
}

const MINUTE = 60_000;
const HOUR = 3_600_000;
const DAY = 86_400_000;

export function formatRelativeTime(epochMs: number): string {
    const diff = Date.now() - epochMs;
    if (diff < MINUTE) return 'Just now';
    if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m ago`;
    if (diff < DAY) return `${Math.floor(diff / HOUR)}h ago`;
    if (diff < DAY * 2) return 'Yesterday';
    return new Date(epochMs).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
    });
}
